/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import React from "react";

const InputLabel = (props:any) => {
    const { labelClasses="", label, type='title' } = props

    const LabelWithNewLine = (text: string ) => {
        return (
          <label>
            {text.split("/n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </label>
        );
      };
    return(
        <React.Fragment>
           {type === 'subTitle' ? <div className={`sub-title ${labelClasses}`}><label className={`${labelClasses}`}>{LabelWithNewLine(label)}</label> </div>: <div className={`title ${labelClasses}`} ><label className={labelClasses}>{LabelWithNewLine(label)}</label></div> }
        </React.Fragment>
    )
}
export default InputLabel;
